import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/railways-item-03-1024.jpg")